import { Controller } from "@hotwired/stimulus";
import QRCode from "qrcode";

// Connects to data-controller="qrcode"
export default class extends Controller {
  static targets = ["qrcode"];

  connect() {
    this.generateQRCode();
  }

  generateQRCode() {
    QRCode.toDataURL(this.qrcodeTarget.dataset.text, { margin: 0, width: 200 }).then((url) => {
      this.qrcodeTarget.src = url;
    });
  }
}
